import React, { useState } from "react";
import { Text } from "@sitecore-jss/sitecore-jss-react";

import AuthImage from "@/react-components/AuthImage";
import { fontSizeEnum, positionEnum } from "@/utils/enum";

const Image2Section = (props) => {
  const [imageOne] = useState(props?.fields?.imageOne?.value?.src);
  const [imageTwo] = useState(props?.fields?.imageTwo?.value?.src);

  const fields = props?.fields;

  // 左画像タイトルフォントスタイル
  const titleFontSizeOne = (() => {
    switch (fields?.titleFontSizeOne?.value?.toLowerCase()) {
      case fontSizeEnum.middle:
        return "title-font-size-middle";
      case fontSizeEnum.small:
        return "title-font-size-small";
      default:
        return "title-font-size-big";
    }
  })();
  // 左補足説明フォントスタイル
  const descFontSizeOne = (() => {
    switch (fields?.descFontSizeOne?.value?.toLowerCase()) {
      case fontSizeEnum.middle:
        return "desc-font-size-middle";
      case fontSizeEnum.small:
        return "desc-font-size-small";
      default:
        return "desc-font-size-big";
    }
  })();
  // 左位置
  const positionOne = (() => {
    switch (fields?.positionOne?.value?.toLowerCase()) {
      case positionEnum.center:
        return "center";
      case positionEnum.right:
        return "right";
      default:
        return "left";
    }
  })();
  // 該当左画像表示エリアは、レポートエリアの幅の表示比率を設定する
  let ratioOne = Math.min(fields?.ratioOne?.value || 0.5, 1) * 100;
  // 右画像タイトルフォントスタイル
  const titleFontSizeTwo = (() => {
    switch (fields?.titleFontSizeTwo?.value?.toLowerCase()) {
      case fontSizeEnum.middle:
        return "title-font-size-middle";
      case fontSizeEnum.small:
        return "title-font-size-small";
      default:
        return "title-font-size-big";
    }
  })();
  // 右補足説明フォントスタイル
  const descFontSizeTwo = (() => {
    switch (fields?.descFontSizeTwo?.value?.toLowerCase()) {
      case fontSizeEnum.middle:
        return "desc-font-size-middle";
      case fontSizeEnum.small:
        return "desc-font-size-small";
      default:
        return "desc-font-size-big";
    }
  })();
  // 右位置
  const positionTwo = (() => {
    switch (fields?.positionTwo?.value?.toLowerCase()) {
      case positionEnum.center:
        return "center";
      case positionEnum.right:
        return "right";
      default:
        return "left";
    }
  })();
  // 該当右画像表示エリアは、レポートエリアの幅の表示比率を設定する
  let ratioTwo = Math.min(fields?.ratioTwo?.value || 0.5, 1) * 100;
  // 位置
  const position = (() => {
    switch (fields?.position?.value?.toLowerCase()) {
      case positionEnum.center:
        return "center";
      case positionEnum.right:
        return "right";
      default:
        return "left";
    }
  })();

  const margin = 40;
  const width = ratioOne + ratioTwo;
  const isExceed = width > 100;
  if (isExceed) {
    ratioOne = `${ratioOne}%`;
    ratioTwo = `${ratioTwo}%`;
  } else {
    ratioOne = `${(ratioOne / width) * 100}%`;
    ratioTwo = `${(ratioTwo / width) * 100}%`;
  }

  return (
    <div className="image-2-section-container">
      <div className={`table-container-main ${position}`}>
        <div
          className={`table-container ${isExceed ? "display-none" : ""}`}
          style={{
            width: `${width}%`,
          }}
        >
          <div className="row-container">
            <div className="cell-container">
              <Text
                field={fields?.titleOne}
                tag="div"
                className={`title ${titleFontSizeOne} ${positionOne}`}
              />
            </div>
            <div className="cell-container" />
            <div className="cell-container">
              <Text
                field={fields?.titleTwo}
                tag="div"
                className={`title ${titleFontSizeTwo} ${positionTwo}`}
              />
            </div>
          </div>
          <div className="row-container">
            <div
              className="cell-container cell-align"
              style={{
                width: ratioOne,
              }}
            >
              {imageOne && <AuthImage src={imageOne} className="image" />}
            </div>
            <div className="cell-container">
              <div
                style={{
                  width: margin,
                }}
              />
            </div>
            <div
              className="cell-container cell-align"
              style={{
                width: ratioTwo,
              }}
            >
              {imageTwo && <AuthImage src={imageTwo} className="image" />}
            </div>
          </div>
          <div className="row-container">
            <div className="cell-container">
              <Text
                field={fields?.descOne}
                tag="div"
                className={`desc ${descFontSizeOne} left`}
              />
            </div>
            <div className="cell-container" />
            <div className="cell-container">
              <Text
                field={fields?.descTwo}
                tag="div"
                className={`desc ${descFontSizeTwo} left`}
              />
            </div>
          </div>
        </div>
      </div>
      <div
        className={`exceed-container ${
          isExceed ? "display-flex" : "display-none"
        } ${position}`}
      >
        <div
          style={{
            width: ratioOne,
          }}
        >
          <Text
            field={fields?.titleOne}
            tag="div"
            className={`title ${titleFontSizeOne} ${positionOne}`}
          />
          {imageOne && <AuthImage src={imageOne} className="image" />}
          <Text
            field={fields?.descOne}
            tag="div"
            className={`desc ${descFontSizeOne} left`}
          />
        </div>
        <div
          style={{
            width: ratioTwo,
          }}
        >
          <Text
            field={fields?.titleTwo}
            tag="div"
            className={`title ${titleFontSizeTwo} ${positionTwo}`}
          />
          {imageTwo && <AuthImage src={imageTwo} className="image" />}
          <Text
            field={fields?.descTwo}
            tag="div"
            className={`desc ${descFontSizeTwo} left`}
          />
        </div>
      </div>
      <div className="phone-container">
        <Text
          field={fields?.titleOne}
          tag="div"
          className={`title ${titleFontSizeOne} ${positionOne}`}
        />
        {imageOne && <AuthImage src={imageOne} className="image" />}
        <Text
          field={fields?.descOne}
          tag="div"
          className={`desc ${descFontSizeOne} left`}
        />
        <Text
          field={fields?.titleTwo}
          tag="div"
          className={`title ${titleFontSizeTwo} ${positionTwo}`}
        />
        {imageTwo && <AuthImage src={imageTwo} className="image" />}
        <Text
          field={fields?.descTwo}
          tag="div"
          className={`desc ${descFontSizeTwo} left`}
        />
      </div>
    </div>
  );
};

export default Image2Section;
